import * as React from 'react'

function CashAppSvg(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width="1em" height="1em" viewBox="0 0 70 70" fill="none" {...props}>
      <path
        d="M54.192 70H15.808A15.808 15.808 0 010 54.192V15.808A15.808 15.808 0 0115.808 0h38.403A15.805 15.805 0 0170 15.808v38.403A15.805 15.805 0 0154.192 70z"
        fill="#00D632"
      />
      <path
        d="M46.513 26.03a1.385 1.385 0 001.97 0l2.734-2.842c.583-.547.546-1.533-.066-2.122a21.555 21.555 0 00-7.35-4.2l.863-4.157a1.452 1.452 0 00-1.4-1.75H37.97a1.44 1.44 0 00-1.4 1.167l-.766 3.694c-7.043.362-13.016 3.938-13.016 11.266 0 6.343 4.933 9.067 10.15 10.938 4.933 1.88 7.548 2.58 7.548 5.228 0 2.722-2.603 4.319-6.453 4.319-3.5 0-7.175-1.167-10.02-4.025a1.42 1.42 0 00-2.01 0l-2.949 2.938a1.486 1.486 0 000 2.1 19.275 19.275 0 008.523 4.812l-.81 3.905a1.453 1.453 0 001.39 1.761l5.304.045a1.445 1.445 0 001.421-1.166l.766-3.709c8.474-.567 13.637-5.238 13.637-12.055 0-6.279-5.141-8.925-11.375-11.083-3.566-1.323-6.65-2.23-6.65-4.955 0-2.646 2.878-3.694 5.765-3.694 3.675 0 7.206 1.52 9.514 3.599l-.027-.014z"
        fill="#fff"
      />
    </svg>
  )
}

export const CashApp = React.memo(CashAppSvg)
